import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";

@Component({
    selector: 'default',
    template: require('./default.component.html')
})

export class DefaultComponent {

    public ham: boolean = false;

    @Input() dataSearch: any;
    @Input() status: any;
    
    constructor(private router: Router) { }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        // Call API for search Information
    }
}